// extracted by mini-css-extract-plugin
export default {"headerPanel":"HeaderPanelStyles_headerPanel__-5HCa","fade-in-panel":"HeaderPanelStyles_fade-in-panel__uZpDq"};